'use strict';

const Key = require('common/domain/value/key');
const Moment = require('moment');
const Backbone = require('backbone');

class CommentReactionAction extends Backbone.Model {
    static get defaults() {
        return {
            userKey: null,
            actionAt: null,
            user: null
        };
    }

    get userKey() {
        return new Key(this.get('userKey'));
    }

    get user() {
        return this.get('user')
    }

    getUserID() {
        return this.user.id;
    }

    getUserName() {
        return this.user && this.user.getName();
    }

    getImageURL() {
        return this.user && this.user.getImageURL();
    }

    get actionAt() {
        return Moment(this.get('actionAt'));
    }
}

module.exports = CommentReactionAction;



// WEBPACK FOOTER //
// ./communication/domain/comment-reaction/action.js